var exports = {
  "QW": "warningIcon__JoanbN",
  "Q$": "referenceTitle__Wseo1L",
  "wg": "referenceSubtitle__PoCpgJ",
  "wf": "referenceTitleLink__wfsIN_",
  "TK": "headerText__Q5q-1S",
  "tF": "repositoryWarning__pz-PG4",
};

module.exports = exports;
